<template>
  <Transition :css="false" @enter="onEnter" @leave="onLeave" @enter-cancelled="cleanup">
    <slot />
  </Transition>
</template>

<script setup>
// Плавное раскрытие блоков-«аккордеонов» (детализация Ккал/Белков/Клетчатки).
//
// height: auto не анимируется в CSS, поэтому — JS-хуки Transition: замеряем
// scrollHeight, анимируем к нему и после конца возвращаем auto — контент
// может менять высоту уже открытым (дооценка клетчатки дописывает строки).
//
// Тайминги: раскрытие 280 мс, сворачивание быстрее (220 мс) — закрытие должно
// ощущаться легче открытия. Кривая — материал-стандарт (быстрый старт, мягкое
// торможение). Контент проявляется с задержкой 80 мс, чтобы блок «выезжал и
// наполнялся», а не мигал текстом в полувысоте.
//
// margin-bottom блока (6px) анимируется вместе с высотой: иначе в конце
// сворачивания страница дёргалась бы на эти 6 пикселей.

const EASE = 'cubic-bezier(0.4, 0, 0.2, 1)'
const MARGIN = '6px'

const reducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches

function cleanup(el) {
  el.style.height = ''
  el.style.opacity = ''
  el.style.overflow = ''
  el.style.transition = ''
  el.style.marginBottom = ''
}

function whenHeightDone(el, done) {
  const end = (e) => {
    if (e.target !== el || e.propertyName !== 'height') return
    el.removeEventListener('transitionend', end)
    cleanup(el)
    done()
  }
  el.addEventListener('transitionend', end)
}

function onEnter(el, done) {
  if (reducedMotion()) return done()
  const target = el.scrollHeight
  el.style.overflow = 'hidden'
  el.style.height = '0'
  el.style.opacity = '0'
  el.style.marginBottom = '0'
  // Принудительный reflow вместо двойного rAF: rAF давал два «мёртвых» кадра,
  // в которые полоска уже анимировалась, а блок стоял на нулевой высоте —
  // раскрытие читалось как «началось, замерло, продолжилось». Чтение
  // offsetHeight синхронно фиксирует стартовые стили, и transition стартует
  // в том же кадре, что и вставка элемента.
  void el.offsetHeight
  el.style.transition = `height .28s ${EASE}, margin-bottom .28s ${EASE}, opacity .2s ease .08s`
  el.style.height = target + 'px'
  el.style.opacity = '1'
  el.style.marginBottom = MARGIN
  whenHeightDone(el, done)
}

function onLeave(el, done) {
  if (reducedMotion()) return done()
  el.style.overflow = 'hidden'
  el.style.height = el.scrollHeight + 'px'
  el.style.marginBottom = MARGIN
  void el.offsetHeight
  el.style.transition = `height .22s ${EASE}, margin-bottom .22s ${EASE}, opacity .16s ease`
  el.style.height = '0'
  el.style.opacity = '0'
  el.style.marginBottom = '0' 
  whenHeightDone(el, done)
}
</script>
